import {
    CORE_GET_ALL_CAR_DRIVER_REQUEST,
    CORE_GET_ALL_CAR_DRIVER_SUCCESS,
    CORE_GET_ALL_CAR_DRIVER_FAILURE,
    CORE_GET_ALL_CAR_DRIVER_FREE_REQUEST,
    CORE_GET_ALL_CAR_DRIVER_FREE_SUCCESS,
    CORE_GET_ALL_CAR_DRIVER_FREE_FAILURE,
    CORE_GET_ALL_MY_JOB_DRIVER_REQUEST,
    CORE_GET_ALL_MY_JOB_DRIVER_SUCCESS,
    CORE_GET_ALL_MY_JOB_DRIVER_FAILURE
} from '../../carReservationType';
import { REQUEST_STATE } from '../../types';

const requestState = REQUEST_STATE;
export default {
    carDriver: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_CAR_DRIVER_REQUEST:
            case CORE_GET_ALL_CAR_DRIVER_FREE_REQUEST:
            case CORE_GET_ALL_MY_JOB_DRIVER_REQUEST:
                return state;
            case CORE_GET_ALL_CAR_DRIVER_SUCCESS:
            case CORE_GET_ALL_CAR_DRIVER_FREE_SUCCESS:
            case CORE_GET_ALL_MY_JOB_DRIVER_SUCCESS:
                if (action.payload) {
                    const { result, data, datas } = action.payload;
                    if (result) {
                        return data ? data : datas;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_GET_ALL_CAR_DRIVER_FAILURE:
            case CORE_GET_ALL_CAR_DRIVER_FREE_FAILURE:
            case CORE_GET_ALL_MY_JOB_DRIVER_FAILURE:
                return {};
            default:
                return state;
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/redux/reducers/carReserve/carDriver.js